import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FooterComponent } from '../footer/footer.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TabButtonComponent } from '../components/tab-button/tab-button.component'; // Import your component
import { AppButtonComponent } from '../components/app-button/app-button.component';
import { AppLoaderComponent } from '../components/app-loader/app-loader.component';
import { ListItemComponent } from '../components/list-item/list-item.component';
import { MySubscriptionCardComponent } from '../components/my-subscription-card/my-subscription-card.component';
import { ServiceItemComponent } from '../components/service-item/service-item.component';
import { AppSliderComponent } from '../components/app-slider/app-slider.component';
import { CategoryListComponent } from '../components/category-list/category-list.component';
import { TestItemComponent } from '../components/test-item/test-item.component';

@NgModule({
  declarations: [
    FooterComponent,
    TabButtonComponent,
    AppButtonComponent,
    AppLoaderComponent,
    ListItemComponent,
    MySubscriptionCardComponent,
    ServiceItemComponent,
    AppSliderComponent,
    CategoryListComponent,
    TestItemComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    IonicModule,
    CommonModule,
    FormsModule,
    TranslateModule,
  ],
  exports: [
    FooterComponent,
    TabButtonComponent,
    AppButtonComponent,
    AppLoaderComponent,
    ListItemComponent,
    MySubscriptionCardComponent,
    ServiceItemComponent,
    AppSliderComponent,
    CategoryListComponent, 
    TestItemComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
